module.exports = __webpack_public_path__ + "static/media/wt.4fd105ce.jpg";